import { ORDER_METHODS } from '../../../../../services/exports/Constants';

export default {
  empty_list: "Aucun produit pour l'instant.",
  fields: {
    number: '#',
    image: 'Image',
    name: 'Nom',
    external_id: 'Réf. {{integration}}',
    price: 'Prix',
    prices: 'Prix',
    description: 'Description',
    tags: 'Tags',
    status: 'Statut',
    product_type: 'Type',
    statuses: {
      good: 'Bon',
      bad: 'Mauvais',
      medium: 'Moyen',
    },
    product_types: {
      packaged: 'Emballé',
      prepared: 'Préparé',
    },
  },
  labels: {
    visible: 'Visible dans le menu',
    hidden: 'Tout masqué',
  },
  order_method_prices: {
    base: 'Base',
    [ORDER_METHODS.pickup]: 'À emporter',
    [ORDER_METHODS.delivery]: 'Livraison',
    [ORDER_METHODS.room_service]: 'Service en chambre/table',
  },
  buttons: {
    delete_products_one: 'Supprimer le produit',
    delete_products_other: 'Supprimer les produits',
    add_product: '+ Ajouter un produit',
    show_products: 'Afficher les produits',
    hide_products: 'Masquer les produits',
    add: 'Ajouter',
    edit: 'Modifier',
    duplicate: 'Dupliquer',
    history: 'Historique',
    delete: 'Supprimer',
    delete_all: 'Tout supprimer',
  },
  toasts: {
    failed_to_duplicate_category: 'Échec de la duplication de la catégorie',
    category_duplicated_successfully: 'Catégorie dupliquée avec succès',
    failed_to_duplicate_product: 'Échec de la duplication du produit',
    product_duplicated_successfully: 'Produit dupliqué avec succès',
    failed_to_delete_variant: 'Échec de la suppression du variant',
    variant_got_deleted: 'Variant supprimé',
    something_went_wrong: 'Une erreur est survenue',
  },
};
